export enum LoadingState {
  IDLE = "idle", // The data is not currently being fetched.
  LOADING = "loading", // The data is currently being fetched.
  SUCCESS = "success", // The data was fetched successfully.
  ERROR = "error", // There was an error fetching the data
}
